/**
 * @desc deliveryDealPushToEbs
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.DeliveryDealRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/test/deliveryDealPushToEbs`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
